import React from "react";
import { Row, Col, Form } from "react-bootstrap";

import NumberSelect from "../../select/numeric";
import { wordsOrdinal, between } from "../../../utils/number";
import { deepEqual } from "../../../utils/object";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }
    
    componentDidUpdate(oldProps) {
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? {};
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });   
    }

    onChange = (e) => {
        const newValue = e.target.value;
        if (this.state.data === newValue) return;
        
        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    onNumericChange = (e) => {
        if (between(this.state.configuration.maximum, this.state.configuration.minimum, Number(e.value))) {
            this.onChange({ target: { name: this.props.element, value: e.value } });
        }
    }

    render() {
        return (<>
            <Row className="g-3">
                <Col>
                    <div className="mb-3 top-label">
                        {(this.state.locked) ?
                            <Form.Control type="text" name={this.props.element} value={wordsOrdinal(this.state.data) || ""} readOnly={this.state.locked} />
                            :
                            <NumberSelect value={this.state.data} minValue={this.state.configuration.minimum} maxValue={this.state.configuration.maximum} suffix={true} onChange={this.onNumericChange} placeholder="" name={this.props.element} />
                        }
                        <Form.Label>{ this.state.label }</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default Name;